import { useTheme } from '@material-ui/core/styles';
import { resolveTokens, DsResolvedTokens } from './tokens';

export function useDsTokens(): DsResolvedTokens {
  const theme = useTheme();
  const mode = theme.palette.type === 'dark' ? 'dark' : 'light';
  return resolveTokens(mode, theme.palette.primary.main);
}
